import React from "react";
import { AffiliateTitleIcon } from "../Icons/AffiliateTitleIcon";
import { useApp } from "../../contexts";
import { ArrowRightIcon } from "../Icons/ArrowRightIcon";
import { ViewFullReport } from "./ViewFullReport";
import { AffiliateLink } from "./AffiliateLink";
import { useState, useEffect } from "react";
import { GenerateAffiliateLink } from "./GenerateAffiliateLink";
import { agreePolicy } from "../../services/app";
import { LabelTableViewAll } from "../../pages/Home/styles";
import { SlideOption } from "./SlideOption";
import { SlideEvent } from "./SlideEvent";
import { TextTitle } from "./styles";
import { MainCardAffiliate } from "./MainCardAffiliate";
import { SlideMainCardAffiliate } from "./SlideMainCardAffiliate";
import { Link, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { ModalPolicy } from "./ModalPolicy";
import environment from "../../environment";
import { ZENDESK_URLS } from "../../constants";

export const AffiliateComponent = ({ isHome, isPage, data = {} }) => {
  const { T, user, reloadProfile, language } = useApp();
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [searchParams] = useSearchParams();
  const appParams = searchParams.get("app");
  const handleOpenModalAgreement = () => {
    setIsOpenModal(true);
  };
  const handleConfirmAgreement = () => {
    agreePolicy().then((res) => {
      if (appParams == 1) {
        if (
          navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPod/i)
        ) {
          window.location.replace(`${environment.SCHEMA_APP}://affiliate`);
        } else if (
          navigator.userAgent.match(/android/i) ||
          navigator.userAgent.match(/Android/i)
        ) {
          window.location.replace(`${environment.SCHEMA_APP}://affiliate`);
        } else {
          // navigate("/affiliate");
          redirectToMlm();
        }
      }
      setIsOpenModal(false);
      reloadProfile();
      redirectToMlm();
    });
  };

  const redirectToMlm = () => {
    const urlMlmRegistration = getMlmRegistrationUrl();
    if (user.evf_affid) {
      window.open(environment.MLM_LOGIN_URL);
    } else {
      window.open(urlMlmRegistration);
    }
  }

  const getMlmRegistrationUrl = () => {
    try {
      const urlMlmRegistration = new URL(environment.MLM_REGISTRATION_URL);
      if (user.email) {
        urlMlmRegistration.searchParams.append("email", user.email);
      }
      return urlMlmRegistration;
    }
    catch (error) {
      console.error(error)
      return environment.MLM_REGISTRATION_URL;
    }
  }

  useEffect(() => {
    if (appParams == 1) {
      setIsOpenModal(true);
    }
  }, [appParams])
  useEffect(() => {
    if (isOpenModal) {
      document.getElementById("root").classList.add("overflow-hidden");
      document
        .getElementsByTagName("html")[0]
        ?.classList.add("overflow-hidden");
    } else {
      document.getElementById("root").classList.remove("overflow-hidden");
      document
        .getElementsByTagName("html")[0]
        ?.classList.remove("overflow-hidden");
    }
  }, [isOpenModal]);
  return (
    <>
      {!user.is_agree_policy ? (
        <div className="affiliate-container-no-code">
          <div className="flex suzu_flex_wrap lg:flex-nowrap ">
            <div
              className="text-aia-red text-center lg:text-left text-[25px] lg:text-[40px] xls:text-[50px] font-manrope leading-[40px] 
              lg:leading-[60px] xl:leading-[70px] font-[600] lg:font-[700] w-full
              mb-[14px] pt-[15px]"
            >
              {T("JOIN OUR EXTREME PROFITABLE COMMUNITY")}
            </div>
          </div>
          <div className="mb-[45px] text-center leading-[26px] lg:leading-[20px] lg:text-left ">
            <span
              className="text-[16px] xls:text-[20px] text-[#000000] 
              leading-[20px] mb-[25px] "
            >
              {T(
                "We created one of the most powerfull & fast growing commision structures in the world"
              )}
            </span>
          </div>
          <div className="flex flex-wrap lg:flex-nowrap flex-col-reverse lg:flex-row lg:mt-[35px] mt-[20px]">
            <div className="w-full flex justify-between lg:space-x-[20px] xl:space-x-[35px] flex-wrap lg:flex-nowrap">
              <div className="affiliate-info-norefer w-full mb-[15px] lg:mb-0 flex justify-between lg:w-[100%]">
                <div className="lg:flex lg:flex-col w-[100%] lg:h-[500px]">
                  <div className="flex lg:flex-row flex-col lg:justify-between justify-between items-center w-[100%]">
                    <div className="box-commission-affi">
                      <div>
                        <span className="xls:text-[73.929px] lg:text-[52px] text-[73.929px] leading-[73px] text-aia-red font-bold">
                          10
                        </span>
                        <span className="text-[#F3850F] font-bold text-[40px]">
                          %
                        </span>
                      </div>
                      <span className="lg:text-[14px] xls:text-[16px] text-[#000000] text-[20px] tracking-[2px] font-semibold leading-[21px] uppercase w-full lg:max-w-[150px] max-w-[220px] text-center">
                        {T("DIRECT SALE COMMISION")}
                      </span>
                    </div>
                    <div className="box-commission-affi">
                      <div>
                        <span className="xls:text-[73.929px] lg:text-[52px] text-[73.929px] leading-[73px] text-aia-red font-bold">
                          10
                        </span>
                        <span className="text-[#F3850F] font-bold text-[40px]">
                          %
                        </span>
                      </div>
                      <span className="lg:text-[14px] xls:text-[16px] text-[#000000] text-[20px] tracking-[2px] leading-[21px] font-semibold uppercase w-[100%] lg:max-w-[170px] max-w-[220px] text-center">
                        {T("TEAM AFFILIATE COMMISION")}
                      </span>
                    </div>
                    <div className="box-commission-affi relative">
                      <div className="absolute top-0 left-0 bg-[#000000] text-[16px] text-[#FFFFFF] font-semibold pl-[7px] pr-[7px] rounded-tl-[8px]">
                        {T("Up to")}
                      </div>
                      <div>
                        <span className="xls:text-[73.929px] lg:text-[52px] text-[73.929px] leading-[73px] text-aia-red font-bold">
                          50
                        </span>
                        <span className="text-[#F3850F] font-bold text-[40px]">
                          %
                        </span>
                      </div>
                      <span className="lg:text-[14px] xls:text-[16px] text-[#000000] text-[20px] tracking-[2px] leading-[21px] font-semibold uppercase w-full lg:max-w-[200px] max-w-[240px] text-center">
                        {T("My TEAM AFFILIATE COMMISION")}
                      </span>
                    </div>
                  </div>
                  <div className="text-[#F3850F] text-[16px] leading-[30px] justify-center lg:justify-start flex items-center lg:mt-[15px] mt-[30px]">
                    <span className="mr-[10px]">
                      {language === "en" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.EN.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "ja" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.JA.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "ko" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.KO.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "cn" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.CN.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "tc" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.TC.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "vi" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.VI.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "id" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.ID.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "pt" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.PT.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                      {language === "es" && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={ZENDESK_URLS.ES.AFFILIATE}
                        >
                          {T("Read more")}
                        </a>
                      )}
                    </span>
                    <span>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 5L12 5"
                          stroke="#393DB8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9 1L13 5L9 9"
                          stroke="#393DB8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="mt-[30px] font-inter">
                    <div>
                      <span className="text-aia-red xls:text-[30px] lg:text-[24px]  text-[20px] leading-[28px]">
                        {T("Becoming member is totally free")}
                      </span>
                    </div>
                    <div className="mt-[12px] mb-[30px]">
                      <span className="text-[#000000] xls:text-[20px] lg:text-[16px] text-[16px]">
                        {T(
                          "Join the network, invite your friend and enjoy benefit together."
                        )}
                      </span>
                    </div>
                    <button
                      data="affiliate-item-join"
                      onClick={() => handleOpenModalAgreement()}
                      className="bg-[#000000] text-[#ffffff] rounded-[14px] lg:w-[192px] h-[52px] w-[100%]"
                    >
                      {T("Join now")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="background-left-affiliate max-h-[300px] h-[100%] w-[100%] relative z-1">
                <div className="font-inter-regular left-0 right-0 ml-auto mr-auto absolute lg:max-w-[calc(100%-50px)] top-[20px] lg:top-[40px] max-w-[330px]">
                  <div className="text-[#ffffff] font-bold xls:text-[28px] text-[20px] leading-[28px] pb-[15px]">
                    {T("About AI AVATAR AFFILIATE")}
                  </div>
                  <div className="text-[#ffffff] lg:font-bold text-[16px] lg:text-[14px] xls:text-[16px] w-[100%] max-w-full leading-[28px]">
                    {T(
                      "Explore our alluring business model and commission structure, revealing remarkable opportunitie"
                    )}
                  </div>
                </div>
                <div className="background-left-youtube xl:w-[360px] z-1 xl:h-[226px] lg:h-[200px] max-w-[390px] max-h-[110px] w-[100%] h-[260px] 
                  rounded-[20px] absolute lg:bottom-[20px] bottom-[20px] left-0 right-0 ml-auto mr-auto">
                  <a
                    href={"https://www.youtube.com/channel/UCTrSAg9bcBaCO6SVoRVPa5Q"}
                    target="_blank"
                    className="flex justify-center items-center z-1 h-[100%] flex-col relative cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-[30px] lg:mt-[24px] xls:mt-[44px]">
          <div className={`affiliate-block ${isPage ? "is-page" : ""}`}>
            <div
              className="flex items-center justify-between px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xl:py-[22px] xls:px-[50px] xls:py-[27px]"
            >
              <div className="flex gap-2 items-center">
                {/* <AffiliateTitleIcon /> */}
                <TextTitle>{T("Earning Overview")}</TextTitle>
              </div>
              {isHome && (
                <LabelTableViewAll
                  className="flex gap-1 cursor-pointer"
                  onClick={() => navigate("/affiliate")}
                >
                  {T("View all")}
                  <ArrowRightIcon color="#818181" />
                </LabelTableViewAll>
              )}
            </div>
            <div className="affiliate-block-items">
              {isPage && <SlideMainCardAffiliate data={data} />}
              {isHome && <MainCardAffiliate data={data} />}
            </div>
          </div>
          <div className="mt-[50px] flex flex-col lg:flex-row gap-5 w-full">
            <div className="w-[100%] lg:w-[45%]">
              <SlideOption data={data} />
            </div>
            {/* {isPage && (
          <div className="text-right px-6 lg:hidden block">
            <Text15>{T("View Full Report")}</Text15>
          </div>
        )} */}
            <div className="w-[100%] lg:w-[55%] mt-5 lg:mt-0">
              <SlideEvent />
            </div>
          </div>
          {isPage && (
            <>
              <div className="mt-[50px] w-full">
                {isPage && (
                  <div className="w-[100%]">
                    <ViewFullReport mlmUrl={data.mlmUrl} />
                  </div>
                )}
              </div>
              <div className="w-[100%] mt-[40px]">
                <AffiliateLink data={data} />
              </div>
              {/* {!isMobile && <Divider style={{ marginTop: 50 }} />} */}

              {/* <div className="mt-[50px]">
          <GenerateAffiliateLink />
        </div> */}
            </>
          )}
        </div>
      )}
      {isOpenModal && (
        <ModalPolicy
          onClose={() => setIsOpenModal(false)}
          handleSubmit={() => handleConfirmAgreement()}
        ></ModalPolicy>
      )}
    </>
  );
};
